// extracted by mini-css-extract-plugin
module.exports = {"sectionCard":"seals_sectionCard__2Zgh_","leftField":"seals_leftField__1219F","rightField":"seals_rightField__34Kll","sealsContainer":"seals_sealsContainer__RVNru"};